import axios from 'axios';

export const getThumbnailBlob = async (thumb: string) => {
  const res = await axios.get<Blob>(thumb, {
    responseType: 'blob',
  });

  return res.data;
};
